module.exports = __webpack_public_path__ + "img/logo-both-2x.32215c44.jpg";